import { render, staticRenderFns } from "./Watney.vue?vue&type=template&id=480f853c&"
import script from "./Watney.vue?vue&type=script&lang=js&"
export * from "./Watney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports